module.exports = __webpack_public_path__ + "img/tx.rate.weekly.443dbad2.png";